import { Component } from '@angular/core';

@Component({ standalone: false, selector: 'app-footerbar',
  templateUrl: './footerbar.component.html',
  styleUrls: ['./footerbar.component.scss']
})
export class FooterbarComponent {


}
